module.exports = __webpack_public_path__ + "img/cucina_prima.189b4d7e.jpg";